import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { XInput } from '@swordhealth/ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'SwordInput',
  props: {
    value: {},
    type: {}
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

/**
 * Bridge component: Vue 2 v-model (value/input) → Vue 3 XInput (modelValue/update:modelValue)
 *
 * Required while using @vue/compat in MODE: 2.
 * Once compat is removed or MODE is set to 3 globally, delete this file
 * and map SwordTextWuk/SwordPasswordWuk directly to XInput in global-components.ts
 */


const emit = __emit

function handleUpdate(newValue: string | number | boolean | object) {
  emit('input', newValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(XInput), _mergeProps(_ctx.$attrs, {
    type: __props.type,
    "model-value": __props.value,
    "onUpdate:modelValue": handleUpdate
  }), null, 16, ["type", "model-value"]))
}
}

})